import { render, staticRenderFns } from "./FurnitureCategories.vue?vue&type=template&id=3a37c04d&"
import script from "./FurnitureCategories.vue?vue&type=script&lang=js&"
export * from "./FurnitureCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports